var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifySafeAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.484 2.65493L10.2632 1.09872C10.0922 1.04782 9.90744 1.04782 9.7365 1.09872L4.51567 2.65493C3.68559 2.90142 2.96352 3.3755 2.45204 4.00979C1.94057 4.64409 1.6657 5.40634 1.66651 6.18826V10.0002C1.66651 15.6343 9.33317 18.746 9.6615 18.8756C9.76802 18.9179 9.88328 18.9398 9.99984 18.9398C10.1164 18.9398 10.2317 18.9179 10.3382 18.8756C10.6665 18.746 18.3332 15.6343 18.3332 10.0002V6.18826C18.334 5.40634 18.0591 4.64409 17.5476 4.00979C17.0362 3.3755 16.3141 2.90142 15.484 2.65493Z",
    fill: "#71DD5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.484 2.65488L10.2632 1.09872C10.0922 1.04782 9.90744 1.04782 9.7365 1.09872L4.51567 2.65488C3.68559 2.90136 2.96352 3.37542 2.45204 4.00969C1.94057 4.64396 1.6657 5.40619 1.66651 6.18808V9.99989C1.66651 15.6338 9.33317 18.7454 9.6615 18.875C9.76802 18.9173 9.88328 18.9391 9.99984 18.9391C10.1164 18.9391 10.2317 18.9173 10.3382 18.875C10.6665 18.7454 18.3332 15.6338 18.3332 9.99989V6.18808C18.334 5.40619 18.0591 4.64396 17.5476 4.00969C17.0362 3.37542 16.3141 2.90136 15.484 2.65488ZM16.6665 9.99989C16.6665 14.0635 11.4007 16.7288 9.99984 17.3665C8.59734 16.7311 3.33317 14.0739 3.33317 9.99989V6.18808C3.33322 5.71898 3.4984 5.26179 3.80531 4.88128C4.11222 4.50077 4.54529 4.21625 5.04317 4.06801L9.99984 2.59081L14.9565 4.06801C15.4544 4.21625 15.8875 4.50077 16.1944 4.88128C16.5013 5.26179 16.6665 5.71898 16.6665 6.18808V9.99989Z",
    fill: "#71DD5F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89209 9.28543L9.68229 12.0756L13.493 6.97838",
    stroke: "#71DD5F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifySafeAddress);
export default __webpack_public_path__ + "static/media/verifySafeAddress.dd7a77ebc7260e813d4ec297cfa3ecef.svg";
export { ForwardRef as ReactComponent };